import React from "react";
import PropTypes from "prop-types";
//Material imports
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import makeStyles from "@mui/styles/makeStyles";
import StepConnector from "@mui/material/StepConnector";
import SectionHeader from "../section-header/SectionHeader";
import MediaContent from "../media-content/MediaContent";
//limitless imports
import { stepsImage } from "@limitless/images";
const useStyles = makeStyles(theme => ({
  mainContainer: {
    ...theme.grid.gridTemplateContainer,
    gridTemplateAreas: `"title"
                            "media"
                            "stepsContent"`,
    marginTop: "2%",
    minWidth: 50,
    textAlign: "left"
  },
  connectorLine: {
    borderColor: "#408290",
    marginLeft: 15,
    height: 65,
    borderLeftWidth: 2
  },
  rootContent: {
    backgroundColor: "transparent",
    padding: 10
  },
  imageContainer: {
    gridArea: "media",
    display: "flex",
    justifyContent: "center"
  },
  stepContent: {
    backgroundColor: "#408290",
    color: theme.palette.secondary.contrastText,
    zIndex: 1,
    width: 54,
    height: 54,
    display: "flex",
    borderRadius: "50%",
    justifyContent: "center",
    alignItems: "center"
  },
  typographyContainer: {
    paddingLeft: "5%",
    "& *": {
      marginBottom: 16
    }
  },
  timeTextContent: {
    fontWeight: 500
  },
  stepContainer: {
    gridArea: "stepsContent"
  },
  headerContainer: {
    gridArea: "title"
  },
  [theme.breakpoints.up("sm")]: {
    mainContainer: {
      gridTemplateColumns: "1fr 1fr",
      gridTemplateAreas: `". title"
                                    "media stepsContent"`
    },
    rootContent: {
      padding: "24px 10px 0px 0px"
    }
  },
  [theme.breakpoints.up("lg")]: {
    stepContent: {
      width: 80,
      height: 80
    },
    connectorLine: {
      marginLeft: 26,
      height: 61
    },
    vertical: {
      padding: "4px 0px"
    }
  }
}));
const StepsContent = ({
  content,
  extraHeaderStyle = "",
  bottomSpaceContainer = ""
}) => {
  const classes = useStyles();
  return /*#__PURE__*/React.createElement(Grid, {
    className: `${classes.mainContainer} ${bottomSpaceContainer}`
  }, /*#__PURE__*/React.createElement(Grid, {
    className: classes.headerContainer
  }, /*#__PURE__*/React.createElement(SectionHeader, {
    header: content.header,
    extraHeaderStyle: extraHeaderStyle
  })), /*#__PURE__*/React.createElement(Grid, {
    className: classes.imageContainer
  }, /*#__PURE__*/React.createElement(MediaContent, {
    content: content,
    noImageSrc: stepsImage
  })), /*#__PURE__*/React.createElement(Stepper, {
    className: classes.stepContainer,
    orientation: "vertical",
    classes: {
      root: classes.rootContent
    },
    connector: /*#__PURE__*/React.createElement(StepConnector, {
      classes: {
        line: classes.connectorLine,
        vertical: classes.vertical
      }
    })
  }, content.steps.map((item, index) => /*#__PURE__*/React.createElement(Step, {
    key: index
  }, /*#__PURE__*/React.createElement(StepLabel, {
    StepIconComponent: () => /*#__PURE__*/React.createElement(Typography, {
      variant: "subtitle2",
      className: classes.stepContent
    }, `0${index + 1}`)
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    lg: 9,
    className: classes.typographyContainer
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    color: "textPrimary"
  }, item.header), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    color: "textPrimary"
  }, item.text), /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle2",
    color: "textPrimary"
  }, item.timeTaken)))))));
};
StepsContent.propTypes = {
  content: PropTypes.object.isRequired,
  extraHeaderStyle: PropTypes.string,
  bottomSpaceContainer: PropTypes.string
};
export default StepsContent;